module.exports = __webpack_public_path__ + "assets/img/neoprene-shoe-high.b18a5259.png";